<template>
    <div class="uk-padding " >
        <div class="uk-container uk-container-small">
            <h1 class="uk-text-center"  style="color: #004e9c;">Services</h1>
            <p class="uk-text-center uk-text-muted">Here are some services offered by us:</p>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <h3 class="uk-heading-bullet">App Development</h3>
                    <p>
                        We provide customizable solutions to fulfill your business needs and reflect your business processes.
                    </p>
                </div>
                <div>
                    <h3 class="uk-heading-bullet">Project Management</h3>
                    <p>
                        Need help managing your IT project? Our team of experts are available to provide guidance to your development needs.
                    </p>
                </div>
                <div>
                    <h3 class="uk-heading-bullet">Cloud Services</h3>
                    <p>
                        Need to deploy a solution but don’t have the server architecture? Take advantage of our cost
                        effective software as a service options.Please call for details.
                    </p>
                </div>
                <div>
                    <h3 class="uk-heading-bullet">Technical Support</h3>
                    <p>
                        We provide ongoing on-site or remote support for all our deployed solutions. A service level agreement will be made available upon contract signing.
                    </p>
                </div>
            </div>
            <div class="uk-text-center">
                <br>

                <router-link to="/productservices" class="uk-button uk-button-default uk-text-capitalize " >Learn More
                <span uk-icon="arrow-right"></span></router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "services"
    }
</script>

<style scoped>
    h3{
        color: #800000
    }
</style>